import type { WorkspaceTransport } from "./workspace-transport";
export function workspaceModuleAllowed(
  transport: WorkspaceTransport,
  module: string,
) {
  if (transport.demo) return true;
  const can = transport.can;
  // Shared library pages carry the permissions of their project counterparts.
  if (module === "library-outputs")
    return workspaceModuleAllowed(transport, "outputs");
  if (module === "library-integrations")
    return workspaceModuleAllowed(transport, "integrations");
  if (module === "library-appearance")
    return can("tenant.setup.manage") || can("tenant.documents.manage");
  if (module === "library" || module.startsWith("library-"))
    return workspaceModuleAllowed(
      transport,
      module.replace("library", "resources"),
    );
  if (module === "help") return can("tenant.help.view");
  if (["projects", "overview", "summary", "integrations"].includes(module))
    return can("tenant.documents.view");
  if (["configuration", "reusable-forms", "designer", "outputs", "settings"].includes(module))
    return can("tenant.documents.manage");
  if (module === "proof" || module === "profiles")
    return can("tenant.proofs.use");
  if (module === "bulk") return can("tenant.proofs.generate");
  if (module === "setup") return can("tenant.setup.manage");
  if (module === "access") return can("tenant.users.manage");
  if (module === "operations") return can("tenant.renders.operate");
  if (module === "resources-assets") return can("tenant.assets.manage");
  if (module === "resources-fonts") return can("tenant.fonts.manage");
  if (module.startsWith("resources"))
    return can("tenant.resources.manage") || can("tenant.documents.manage");
  return false;
}
